import React from 'react';
import { Link } from 'react-router-dom';
import {
    Button,
    Form,
    Row,
    Col,
    Select,
    Input,
    DatePicker, Popconfirm, message,
} from 'antd';
const { RangePicker } = DatePicker;
const FormItem = Form.Item;
import { actions, asyncGet ,delAllCommand} from './reducers';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
import { commendList } from '../../../utils/';
import {formatFormData} from './utils';
const spans = {
    xs: 14,
    sm: 14,
    md: 6,
    lg: 6,
    xl: 6,
};

class Search extends React.Component {
    constructor(props) {
        super(props);
    }

    handleReset= () => {
        this.props.form.resetFields();
    }

    // 查询
    handleSearch = () => {
        let values = this.props.form.getFieldsValue();
        for (let i in values) {
            if (values[i] == -1 || values[i] === '' || values[i] === undefined) {
                delete values[i];
            }
        }
        values = formatFormData(values);
        console.log('=====searchValue', values);
        this.props.changeSearchValues(values);
        this.props.resetPagination();
        this.props.asyncGet();
    }
    // 批量删除调用批量删除接口
    deleteALLCommand = async () => {
       await this.props.delAllCommand();
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const commendOptions = commendList.map(i => {
            return (<Option value={i.value}>{i.name}</Option>);
        });
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>下发命令列表</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{ marginBottom: '10px' }}>
                        <Col span={8}>
                            <FormItem {...spans} label="时间段">
                                {getFieldDecorator('dateTime')(
                                    <RangePicker
                                        showTime
                                        format="YYYY-MM-DD HH:mm:ss"
                                        placeholder="选择时间"
                                    />)}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem {...spans} label="设备ID">
                                {getFieldDecorator('clientIds')(<Input placeholder="请填写" style={{ width: '100%' }} />)}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem {...spans} label="操作人">
                                {getFieldDecorator('executor')(<Input placeholder="请填写" style={{ width: '100%' }} />)}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem label="命令类型" {...spans}>
                                {getFieldDecorator('action')(
                                    <Select allowClear placeholder="全部" style={{ width: 160 }}>
                                        {commendOptions}
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <Button style={{ margin: '0 8px' }} onClick={this.handleReset}>
                                重置
                            </Button>
                            <Button type="primary" onClick={this.handleSearch} style={{ margin: '0 8px' }}>
                                搜索
                            </Button>
                            <Popconfirm
                                title='确认删除'
                                okText='确定'
                                cancelText='取消'
                                onConfirm={() => {
                                    this.deleteALLCommand();
                                }}>
                                <Button type="danger" style={{ marginRight: '5px' }}>
                                    删除所有命令
                                </Button>
                            </Popconfirm>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    changeSearchValues: values => dispatch(actions.changeSearchValues(values)),
    resetPagination: () => dispatch(actions.changePagination({ current: 1 })),
    asyncGet: () => dispatch(asyncGet()),
    delAllCommand: () => dispatch(delAllCommand()),
});

export default connect(null, mapDispatchToProps)(Form.create()(Search));



// WEBPACK FOOTER //
// ./pages/client/commendList/search.js